import PropTypes from "prop-types";
import { PureComponent } from "react";
import { Prism as SyntaxHighlighter } from "react-syntax-highlighter";
import darcula from "react-syntax-highlighter/dist/cjs/styles/prism/darcula";

export interface CodeBlockProps {
  value: string;
  language?: string;
}

class CodeBlock extends PureComponent<CodeBlockProps, {}> {
  static propTypes = {
    value: PropTypes.string.isRequired,
    language: PropTypes.string,
  };

  static defaultProps = {
    language: null,
  };

  render() {
    const { language, value } = this.props;
    return (
      <SyntaxHighlighter language={language} style={darcula}>
        {value}
      </SyntaxHighlighter>
    );
  }
}

export default CodeBlock;
